"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var styles = styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: #333333;\n  color: #fff;\n  text-transform: uppercase;\n  padding: 0.5em 1em;\n  display: inline-block;\n  white-space: nowrap;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n    ", "\n"], ["\n  background-color: #333333;\n  color: #fff;\n  text-transform: uppercase;\n  padding: 0.5em 1em;\n  display: inline-block;\n  white-space: nowrap;\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n    ",
    "\n"])), function (_a) {
    var type = _a.type;
    return type === 'error' && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: #fe505d;\n    "], ["\n      background-color: #fe505d;\n    "])));
}, function (_a) {
    var type = _a.type;
    return type === 'info' && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-color: #2362a2;\n    "], ["\n      background-color: #2362a2;\n    "])));
}, function (_a) {
    var type = _a.type;
    return type === 'green' && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: #1ca854;\n    "], ["\n      background-color: #1ca854;\n    "])));
}, function (_a) {
    var type = _a.type;
    return type === 'grey' && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: #333333;\n      background-color: #eaeff3;\n    "], ["\n      color: #333333;\n      background-color: #eaeff3;\n    "])));
}, function (_a) {
    var type = _a.type;
    return type === 'subjectType' && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      color: #fff;\n      background-color: #3b3b3b;\n      border-radius: 3px;\n    "], ["\n      color: #fff;\n      background-color: #3b3b3b;\n      border-radius: 3px;\n    "])));
});
var Label = function (_a) {
    var className = _a.className, children = _a.children;
    return react_1.default.createElement("div", { className: className }, children);
};
Label.defaultProps = {
    className: undefined,
    type: 'default',
};
exports.default = styled_components_1.default(Label)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styles);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
